import { useState, useEffect } from "react";
import { Card, Table, Badge, Input, Select, Space, Typography, Button } from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import SoporteReemplazoService from "../../services/documentoReemplazo/SoporteReemplazoService";

const { Title } = Typography;
const { Option } = Select;

const COLOR_ESTADO = {
  1: "gold",
  2: "green",
  3: "orange",
  4: "blue",
  5: "red",
  0: "red",
};

export function HistoricoReemplazos({ codUnicoFiltro }) {
  const [registros, setRegistros] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const [estado, setEstado] = useState("");

  useEffect(() => {
    cargar();
  }, [codUnicoFiltro]);

  useEffect(() => {
    aplicarFiltros();
  }, [registros, busqueda, estado]);

  const cargar = async () => {
    setLoading(true);
    try {
      const data = await SoporteReemplazoService.historico(codUnicoFiltro);
      setRegistros(data);
    } catch (error) {
      console.error("Error al cargar histórico", error);
    } finally {
      setLoading(false);
    }
  };

  const aplicarFiltros = () => {
    let resultado = [...registros];
    if (estado) {
      resultado = resultado.filter(
        (r) => r.estadoReemplazo?.toString() === estado
      );
    }
    if (busqueda) {
      const texto = busqueda.toLowerCase();
      resultado = resultado.filter(
        (r) =>
          r.codUnico?.toLowerCase().includes(texto) ||
          r.nombre_soporte?.toLowerCase().includes(texto) ||
          r.user?.toLowerCase().includes(texto)
      );
    }
    setFiltrados(resultado);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
      align: "center",
    },
    {
      title: "Código",
      dataIndex: "codUnico",
      key: "codUnico",
      width: 110,
      render: (text) => (
        <span style={{ fontFamily: "monospace", fontSize: 12 }}>{text}</span>
      ),
    },
    {
      title: "Usuario",
      dataIndex: "user",
      key: "user",
      width: 100,
      ellipsis: true,
    },
    {
      title: "Soporte nuevo",
      dataIndex: "nombre_soporte",
      key: "nombre_soporte",
      ellipsis: true,
      width: 160,
    },
    {
      title: "Soporte anterior",
      dataIndex: "nombre_soporte_old",
      key: "nombre_soporte_old",
      ellipsis: true,
      width: 160,
      render: (text) =>
        text || <span style={{ color: "#bbb" }}>—</span>,
    },
    {
      title: "Estado",
      dataIndex: "estadoReemplazoTexto",
      key: "estadoReemplazoTexto",
      width: 160,
      align: "center",
      render: (text, record) => (
        <Badge color={COLOR_ESTADO[record.estadoReemplazo]} text={text} />
      ),
    },
    {
      title: "Fecha registro",
      dataIndex: "fecha_reemplazo",
      key: "fecha_reemplazo",
      width: 110,
      align: "center",
      render: (fecha) =>
        fecha && fecha !== "0000-00-00"
          ? new Date(fecha).toLocaleDateString()
          : "—",
    },
    {
      title: "Fecha procesado",
      dataIndex: "fecha_procesado",
      key: "fecha_procesado",
      width: 120,
      align: "center",
      render: (fecha) =>
        fecha && fecha !== "0000-00-00"
          ? new Date(fecha).toLocaleDateString()
          : "—",
    },
    {
      title: "Ruta anterior",
      dataIndex: "ruta_old",
      key: "ruta_old",
      ellipsis: true,
      width: 200,
      render: (text) => {
        if (!text) return <span style={{ color: "#bbb" }}>—</span>;
        return text.replace(
          /DocumentosPOA\/actividad_\d+\/tarea_\d+\/indicador_\d+\/medio_verificacion_\d+\//,
          ""
        );
      },
    },
  ];

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Space wrap>
        <Input
          placeholder="Buscar por código, nombre o usuario"
          prefix={<SearchOutlined />}
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
        <Select
          placeholder="Filtrar por estado"
          value={estado || undefined}
          onChange={(val) => setEstado(val ?? "")}
          allowClear
          style={{ width: 200 }}
        >
          <Option value="1">Pendiente</Option>
          <Option value="2">Procesado con éxito</Option>
          <Option value="3">Duplicado</Option>
          <Option value="4">Documento validado</Option>
          <Option value="5">Documento no encontrado</Option>
          <Option value="0">Error</Option>
        </Select>
        <Button icon={<ReloadOutlined />} onClick={cargar} loading={loading}>
          Actualizar
        </Button>
      </Space>

      <Card
        title={
          <Space>
            <Title level={5} style={{ margin: 0 }}>
              Histórico de Reemplazos
            </Title>
            <Badge count={filtrados.length} style={{ backgroundColor: "#1677ff" }} />
          </Space>
        }
      >
        <Table
          dataSource={filtrados}
          columns={columns}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 15, showSizeChanger: true }}
          scroll={{ x: "max-content" }}
          size="small"
        />
      </Card>
    </Space>
  );
}
